/* eslint-disable react/prop-types */
import { Component, PropsWithChildren, ReactPropTypes } from 'react';
import FullScreenError from './FullScreen';
import logger from '../../utils/logger';

class ErrorBoundary extends Component {
    constructor(props: ReactPropTypes) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error) {
        logger({ id: 'ERROR-BOUNDARY', name: error.name, message: error.message, stack: error.stack || '' });
        return { hasError: true };
    }

    render() {
        const { hasError } = this.state as Readonly<{ hasError: boolean }>;
        const { children } = this.props as PropsWithChildren;

        if (hasError) {
            return <FullScreenError />;
        }

        return children;
    }
}

export default ErrorBoundary;
